import React from 'react';
import { useRef, useEffect } from 'react';

export const useMountEffect = (fun: () => void) => useEffect(fun, []);

const UseFocus = <T extends HTMLElement>(): [React.RefObject<T | null>, () => void] => {
  const htmlElRef = useRef<T>(null);
  const setFocus = () => {
    htmlElRef.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
};

export default UseFocus;